module.exports = __webpack_public_path__ + "cb6261163d7d03669e1bb418489ecfea.png";